export default {
  '固定污染源VOCs在线监测解决方案': {
    'title': '固定污染源VOCs在线监测解决方案',
    'imgUrl': 'static/img/solution/list/111/环保-废水_气监测-固定污染源VOCs在线监测解决方案.jpg'
  },
  '环保-废水_气监测-固定污染源水质在线监测解决方案': {
    'title': '固定污染源水质在线监测解决方案',
    'imgUrl': 'static/img/solution/list/111/环保-废水_气监测-固定污染源水质在线监测解决方案_1.jpg'
  },
  '0103': {
    'title': '固定污染源烟气排放在线监测解决方案',
    'imgUrl': 'static/img/solution/list/111/环保-废水_气监测-固定污染源烟气排放在线监测解决方案.jpg'
  },
  '0201': {
    'title': '固定污染源VOCs在线监测解决方案',
    'imgUrl': 'static/img/solution/list/222/环保-实验室分析-标准溶液配置机器人解决方案.jpg'
  },
  '0202': {
    'title': '固定污染源水质在线监测解决方案_1',
    'imgUrl': 'static/img/solution/list/222/环保-实验室分析-色谱（GC_LC）分析解决方案.jpg'
  },
  '0203': {
    'title': '固定污染源烟气排放在线监测解决方案',
    'imgUrl': 'static/img/solution/list/222/环保-实验室分析-原子发射光谱分析解决方案.jpg'
  },
  '0301': {
    'title': '区域水质在线监测解决方案',
    'imgUrl': 'static/img/solution/list/333/环保-废水监测-区域水质在线监测解决方案.jpg'
  },
  '0302': {
    'title': '固废智能监管解决方案',
    'imgUrl': 'static/img/solution/list/333/环保-固废智能监管-固废智能监管解决方案.jpg'
  },
  '0401': {
    'title': '氨逃逸在线监测解决方案',
    'imgUrl': 'static/img/solution/list/444/环保-组分分析-氨逃逸在线监测解决方案.jpg'
  },
  '0402': {
    'title': '激光气体分析解决方案',
    'imgUrl': 'static/img/solution/list/444/环保-组分分析-激光气体分析解决方案.jpg'
  },
  '0403': {
    'title': '三氧化硫在线监测解决方案',
    'imgUrl': 'static/img/solution/list/444/环保-组分分析-三氧化硫在线监测解决方案.jpg'
  },
  '0404': {
    'title': '在线色谱分析解决方案',
    'imgUrl': 'static/img/solution/list/444/环保-组分分析-在线色谱分析解决方案.jpg'
  },
  '环保-智慧环保-智慧环保-解决方案': {
    'title': '解决方案',
    'imgUrl': 'static/img/solution/list/555/环保-智慧环保-智慧环保-解决方案.jpg'
  },
  '环保-智能运维-智能运维-解决方案': {
    'title': '智能运维',
    'imgUrl': 'static/img/solution/list/555/环保-智能运维-智能运维-解决方案.jpg'
  },
  '安全-安全仪表系统': {
    'title': '安全仪表系统',
    'imgUrl': 'static/img/solution/safe/安全-安全仪表系统.jpg'
  },
  '安全-变更管理': {
    'title': '变更管理',
    'imgUrl': 'static/img/solution/safe/安全-变更管理.jpg'
  },
  '安全-仿真培训-OTS操作员仿真培训': {
    'title': 'OTS操作员仿真培训',
    'imgUrl': 'static/img/solution/safe/安全-仿真培训-OTS操作员仿真培训.jpg'
  },
  '安全-风险评估--工艺危险分析(HAZOP)': {
    'title': '工艺危险分析(HAZOP)',
    'imgUrl': 'static/img/solution/safe/安全-风险评估--工艺危险分析(HAZOP).jpg'
  },
  '安全-功能安全管理--综述': {
    'title': '综述',
    'imgUrl': 'static/img/solution/safe/安全-功能安全管理--综述.jpg'
  },
  '安全-环境因素监测预警': {
    'title': '环境因素监测预警',
    'imgUrl': 'static/img/solution/safe/安全-环境因素监测预警.jpg'
  },
  '安全-日常安全管理': {
    'title': '日常安全管理',
    'imgUrl': 'static/img/solution/safe/安全-日常安全管理.jpg'
  },
  '安全-信息安全管理': {
    'title': '信息安全管理',
    'imgUrl': 'static/img/solution/safe/安全-信息安全管理.jpg'
  },
  '安全-园区安全应急联动': {
    'title': '园区安全应急联动',
    'imgUrl': 'static/img/solution/safe/安全-园区安全应急联动.jpg'
  },
  '安全-远程诊断维护': {
    'title': '远程诊断维护',
    'imgUrl': 'static/img/solution/safe/安全-远程诊断维护.jpg'
  },
  '安全-作业管理': {
    'title': '作业管理',
    'imgUrl': 'static/img/solution/safe/安全-作业管理.jpg'
  },
  '安全-HSE体系管理': {
    'title': 'HSE体系管理',
    'imgUrl': 'static/img/solution/safe/安全-HSE体系管理.jpg'
  },
  '安全-SES中控安全监管和指挥系统': {
    'title': 'SES中控安全监管和指挥系统',
    'imgUrl': 'static/img/solution/safe/安全-SES中控安全监管和指挥系统.jpg'
  },
  '安全-保护层规划--SIL评估': {
    'title': 'SIL评估',
    'imgUrl': 'static/img/solution/safe/安全-保护层规划--SIL评估.jpg'
  },
  '安全-报警管理-先进报警管理系统': {
    'title': '先进报警管理系统',
    'imgUrl': 'static/img/solution/safe/安全-报警管理-先进报警管理系统.jpg'
  },
  '安全-功能安全--综述': {
    'title': '综述',
    'imgUrl': 'static/img/solution/safe/安全-功能安全--综述.jpg'
  },
  '安全-人员定位': {
    'title': '人员定位',
    'imgUrl': 'static/img/solution/safe/安全-人员定位.jpg'
  },
  '安全-事故隐患跟踪治理系统_1': {
    'title': '事故隐患跟踪治理系统_1',
    'imgUrl': 'static/img/solution/safe/安全-事故隐患跟踪治理系统_1.jpg'
  },
  '安全-系统雷击防护-中控防雷服务': {
    'title': '中控防雷服务',
    'imgUrl': 'static/img/solution/safe/安全-系统雷击防护-中控防雷服务.jpg'
  },
  '安全-系统内建安全': {
    'title': '系统内建安全',
    'imgUrl': 'static/img/solution/safe/安全-系统内建安全.jpg'
  },
  '安全-信息安全': {
    'title': '信息安全',
    'imgUrl': 'static/img/solution/safe/安全-信息安全.jpg'
  },
  '安全-信息安全健康诊断与防御': {
    'title': '信息安全健康诊断与防御',
    'imgUrl': 'static/img/solution/safe/安全-信息安全健康诊断与防御.jpg'
  },
  '安全-应急预案': {
    'title': '应急预案',
    'imgUrl': 'static/img/solution/safe/安全-应急预案.jpg'
  },
  '安全-远程运维': {
    'title': '远程运维',
    'imgUrl': 'static/img/solution/safe/安全-远程运维.jpg'
  },
  '安全-智能巡检': {
    'title': '智能巡检',
    'imgUrl': 'static/img/solution/safe/安全-智能巡检.jpg'
  },
  '安全-重大危险源监测预警': {
    'title': '重大危险源监测预警',
    'imgUrl': 'static/img/solution/safe/安全-重大危险源监测预警.jpg'
  },
  '供应链-仓库管理': {
    'title': '仓库管理',
    'imgUrl': 'static/img/solution/gongying/供应链-仓库管理.jpg'
  },
  '供应链-成品油调合': {
    'title': '成品油调合',
    'imgUrl': 'static/img/solution/gongying/供应链-成品油调合.jpg'
  },
  '供应链-罐区管理': {
    'title': '罐区管理',
    'imgUrl': 'static/img/solution/gongying/供应链-罐区管理.jpg'
  },
  '供应链-油品移动': {
    'title': '油品移动',
    'imgUrl': 'static/img/solution/gongying/供应链-油品移动.jpg'
  },
  '供应链-原油调合': {
    'title': '原油调合',
    'imgUrl': 'static/img/solution/gongying/供应链-原油调合.jpg'
  },
  '供应链-终端自动化': {
    'title': '终端自动化',
    'imgUrl': 'static/img/solution/gongying/供应链-终端自动化.jpg'
  },
  '能源_氢气平衡与优化': {
    'title': '氢气平衡与优化',
    'imgUrl': 'static/img/solution/nengyuan/能源_氢气平衡与优化.jpg'
  },
  '能源_瓦斯平衡与优化': {
    'title': '瓦斯平衡与优化',
    'imgUrl': 'static/img/solution/nengyuan/能源_瓦斯平衡与优化.jpg'
  },
  '能源_蒸汽平衡与优化': {
    'title': '蒸汽平衡与优化',
    'imgUrl': 'static/img/solution/nengyuan/能源_蒸汽平衡与优化.jpg'
  },
  '能源-大数据分析': {
    'title': '大数据分析',
    'imgUrl': 'static/img/solution/nengyuan/能源-大数据分析.jpg'
  },
  '能源-能耗基准管理': {
    'title': '能耗基准管理',
    'imgUrl': 'static/img/solution/nengyuan/能源-能耗基准管理.jpg'
  },
  '能源-能流监控': {
    'title': '能流监控',
    'imgUrl': 'static/img/solution/nengyuan/能源-能流监控.jpg'
  },
  '能源-能效监控': {
    'title': '能效监控',
    'imgUrl': 'static/img/solution/nengyuan/能源-能效监控.jpg'
  },
  '能源-能源计划预测': {
    'title': '能源计划预测',
    'imgUrl': 'static/img/solution/nengyuan/能源-能源计划预测.jpg'
  },
  '能源-能源绩效评估': {
    'title': '能源绩效评估',
    'imgUrl': 'static/img/solution/nengyuan/能源-能源绩效评估.jpg'
  },
  '能源-能源实绩分析': {
    'title': '能源实绩分析',
    'imgUrl': 'static/img/solution/nengyuan/能源-能源实绩分析.jpg'
  },
  '能源-能源统计报表': {
    'title': '能源统计报表',
    'imgUrl': 'static/img/solution/nengyuan/能源-能源统计报表.jpg'
  },
  '能源-能源总览': {
    'title': '能源总览',
    'imgUrl': 'static/img/solution/nengyuan/能源-能源总览.jpg'
  },
  '能源-指标查询': {
    'title': '指标查询',
    'imgUrl': 'static/img/solution/nengyuan/能源-指标查询.jpg'
  },
  '能源-指标地图': {
    'title': '指标地图',
    'imgUrl': 'static/img/solution/nengyuan/能源-指标地图.jpg'
  },
  '生产管控-标准任务': {
    'title': '标准任务',
    'imgUrl': 'static/img/solution/shengchan/生产管控-标准任务.jpg'
  },
  '生产管控-工艺管理': {
    'title': '工艺管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-工艺管理.jpg'
  },
  '生产管控-罐区管理': {
    'title': '罐区管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-罐区管理.jpg'
  },
  '生产管控-实验室管理': {
    'title': '实验室管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-实验室管理.jpg'
  },
  '生产管控-物料平衡': {
    'title': '物料平衡',
    'imgUrl': 'static/img/solution/shengchan/生产管控-物料平衡.jpg'
  },
  '生产管控-装置全流程控制优化一体化解决方案': {
    'title': '装置全流程控制优化一体化解决方案',
    'imgUrl': 'static/img/solution/shengchan/生产管控-装置全流程控制优化一体化解决方案.jpg'
  },
  '生产管控 - 操作管理': {
    'title': '操作管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控 - 操作管理.jpg'
  },
  '生产管控 - 辅料管理': {
    'title': '辅料管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控 - 辅料管理.jpg'
  },
  '生产管控 - 计量体系': {
    'title': '计量体系',
    'imgUrl': 'static/img/solution/shengchan/生产管控 - 计量体系.jpg'
  },
  '生产管控 - 库存管理': {
    'title': '库存管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控 - 库存管理.jpg'
  },
  '生产管控-PDA移动操作': {
    'title': 'PDA移动操作',
    'imgUrl': 'static/img/solution/shengchan/生产管控-PDA移动操作.jpg'
  },
  '生产管控-批次工艺分析': {
    'title': '批次工艺分析',
    'imgUrl': 'static/img/solution/shengchan/生产管控-批次工艺分析.jpg'
  },
  '生产管控-批量配方管理': {
    'title': '批量配方管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-批量配方管理.jpg'
  },
  '生产管控-生产计划': {
    'title': '生产计划',
    'imgUrl': 'static/img/solution/shengchan/生产管控-生产计划.jpg'
  },
  '生产管控-生产计划管理': {
    'title': '生产计划管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-生产计划管理.jpg'
  },
  '生产管控-生产计量': {
    'title': '生产计量',
    'imgUrl': 'static/img/solution/shengchan/生产管控-生产计量.jpg'
  },
  '生产管控-生产监控': {
    'title': '生产监控',
    'imgUrl': 'static/img/solution/shengchan/生产管控-生产监控.jpg'
  },
  '生产管控-生产批次管理': {
    'title': '生产批次管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-生产批次管理.jpg'
  },
  '生产管控-生产统计': {
    'title': '生产统计',
    'imgUrl': 'static/img/solution/shengchan/生产管控-生产统计.jpg'
  },
  '生产管控-条码系统管理': {
    'title': '条码系统管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-条码系统管理.jpg'
  },
  '生产管控-调度管理': {
    'title': '调度管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-调度管理.jpg'
  },
  '生产管控-制造工单管理': {
    'title': '制造工单管理',
    'imgUrl': 'static/img/solution/shengchan/生产管控-制造工单管理.jpg'
  },
  '设备管理-设备档案与资产管理': {
    'title': '设备档案与资产管理',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备档案与资产管理.jpg'
  },
  '设备管理-设备监控与数据采集': {
    'title': '设备监控与数据采集',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备监控与数据采集.jpg'
  },
  '设备管理-设备维护管理': {
    'title': '设备维护管理',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备维护管理.jpg'
  },
  '设备管理-设备隐患管理': {
    'title': '设备隐患管理',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备隐患管理.jpg'
  },
  '设备管理-设备远程维护管理': {
    'title': '设备远程维护管理',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备远程维护管理.jpg'
  },
  '设备管理-设备知识库': {
    'title': '设备知识库',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备知识库.jpg'
  },
  '设备管理-设备综合分析': {
    'title': '设备综合分析',
    'imgUrl': 'static/img/solution/shebei/设备管理-设备综合分析.jpg'
  },
  '设备管理-移动作业和综合巡检': {
    'title': '移动作业和综合巡检',
    'imgUrl': 'static/img/solution/shebei/设备管理-移动作业和综合巡检.jpg'
  },
  '环保-边界废气监测-厂界VOCs在线监测解决方案': {
    'title': '厂界VOCs在线监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-边界废气监测-厂界VOCs在线监测解决方案.jpg'
  },
  '环保-废水_气监测-固定污染源VOCs在线监测解决方案': {
    'title': '固定污染源VOCs在线监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-废水_气监测-固定污染源VOCs在线监测解决方案.jpg'
  },
  '环保-废水_气监测-固定污染源水质在线监测解决方案_1': {
    'title': '固定污染源水质在线监测解决方案_1',
    'imgUrl': 'static/img/solution/huanbao/环保-废水_气监测-固定污染源水质在线监测解决方案_1.jpg'
  },
  '环保-废水_气监测-固定污染源烟气排放在线监测解决方案': {
    'title': '固定污染源烟气排放在线监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-废水_气监测-固定污染源烟气排放在线监测解决方案.jpg'
  },
  '环保-废水_气治理-VOCs治理解决方案': {
    'title': 'VOCs治理解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-废水_气治理-VOCs治理解决方案.jpg'
  },
  '环保-废水监测-区域水质在线监测解决方案': {
    'title': '区域水质在线监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-废水监测-区域水质在线监测解决方案.jpg'
  },
  '环保-固废智能监管-固废智能监管解决方案': {
    'title': '固废智能监管解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-固废智能监管-固废智能监管解决方案.jpg'
  },
  "环保-环保e院-'环保e院'解决方案": {
    'title': '环保e院解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环保e院-“环保e院”解决方案.jpg'
  },
  '环保-环保优化设计-VOCs循环化解决方案': {
    'title': 'VOCs循环化解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环保优化设计-VOCs循环化解决方案.jpg'
  },
  '环保-环境风险管理-环境风险管理解决方案': {
    'title': '环境风险管理解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环境风险管理-环境风险管理解决方案.jpg'
  },
  '环保-环境事故联动-环境事故联动解决方案': {
    'title': '环境事故联动解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环境事故联动-环境事故联动解决方案.jpg'
  },
  '环保-环境事故预警-环境事故预警解决方案': {
    'title': '环境事故预警解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环境事故预警-环境事故预警解决方案.jpg'
  },
  '环保-环境效益管理-环境效益管理解决方案': {
    'title': '环境效益管理解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环境效益管理-环境效益管理解决方案.jpg'
  },
  '环保-环境影响评估-环境影响评估解决方案': {
    'title': '环境影响评估解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-环境影响评估-环境影响评估解决方案.jpg'
  },
  '环保-节能减排-VOCs治理效率优化解决方案': {
    'title': 'VOCs治理效率优化解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-节能减排-VOCs治理效率优化解决方案.jpg'
  },
  '环保-节能减排-锅炉焚烧效率优化解决方案': {
    'title': '锅炉焚烧效率优化解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-节能减排-锅炉焚烧效率优化解决方案.jpg'
  },
  '环保-空气质量监测-空气监测站解决方案': {
    'title': '空气监测站解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-空气质量监测-空气监测站解决方案.jpg'
  },
  '环保-末端治理设计-VOCs治理解决方案': {
    'title': 'VOCs治理解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-末端治理设计-VOCs治理解决方案.jpg'
  },
  '环保-区域废气监测-微型空气站解决方案': {
    'title': '微型空气站解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-区域废气监测-微型空气站解决方案.jpg'
  },
  '环保-人员应急预警-人员应急预警解决方案_1': {
    'title': '人员应急预警解决方案_1',
    'imgUrl': 'static/img/solution/huanbao/环保-人员应急预警-人员应急预警解决方案_1.jpg'
  },
  '环保-生产环境监测-危险气体监测网络解决方案': {
    'title': '危险气体监测网络解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-生产环境监测-危险气体监测网络解决方案.jpg'
  },
  '环保-生态园区-生态园区解决方案': {
    'title': '生态园区解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-生态园区-生态园区解决方案.jpg'
  },
  '环保-实验室分析-标准溶液配置机器人解决方案': {
    'title': '标准溶液配置机器人解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-实验室分析-标准溶液配置机器人解决方案.jpg'
  },
  '环保-实验室分析-色谱（GC_LC）分析解决方案': {
    'title': '色谱（GC_LC）分析解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-实验室分析-色谱（GC_LC）分析解决方案.jpg'
  },
  '环保-实验室分析-原子发射光谱分析解决方案': {
    'title': '原子发射光谱分析解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-实验室分析-原子发射光谱分析解决方案.jpg'
  },
  '环保-视情维修-汽轮机视情维修解决方案': {
    'title': '汽轮机视情维修解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-视情维修-汽轮机视情维修解决方案.jpg'
  },
  '环保-污染排放管理-污染排放管理解决方案': {
    'title': '污染排放管理解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-污染排放管理-污染排放管理解决方案.jpg'
  },
  '环保-污染溯源-园区大气污染溯源解决方案': {
    'title': '园区大气污染溯源解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-污染溯源-园区大气污染溯源解决方案.jpg'
  },
  '环保-泄露与修复-泄露检测与修复（LDAR）解决方案': {
    'title': '泄露检测与修复（LDAR）解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-泄露与修复-泄露检测与修复（LDAR）解决方案.jpg'
  },
  '环保-移动监测-移动监测解决方案': {
    'title': '移动监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-移动监测-移动监测解决方案.jpg'
  },
  '环保-移动应急预警-移动应急预警解决方案': {
    'title': '移动应急预警解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-移动应急预警-移动应急预警解决方案.jpg'
  },
  '环保-治理设施监测-治理设施监测解决方案': {
    'title': '治理设施监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-治理设施监测-治理设施监测解决方案.jpg'
  },
  "环保-智慧环保-'智慧环保'解决方案": {
    'title': '智慧环保解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-智慧环保-“智慧环保”解决方案.jpg'
  },
  "环保-智能运维-'智能运维'解决方案": {
    'title': '智能运维解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-智能运维-“智能运维”解决方案.jpg'
  },
  '环保-组分分析-氨逃逸在线监测解决方案': {
    'title': '氨逃逸在线监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-组分分析-氨逃逸在线监测解决方案.jpg'
  },
  '环保-组分分析-激光气体分析解决方案': {
    'title': '激光气体分析解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-组分分析-激光气体分析解决方案.jpg'
  },
  '环保-组分分析-三氧化硫在线监测解决方案': {
    'title': '三氧化硫在线监测解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-组分分析-三氧化硫在线监测解决方案.jpg'
  },
  '环保-组分分析-在线色谱分析解决方案': {
    'title': '在线色谱分析解决方案',
    'imgUrl': 'static/img/solution/huanbao/环保-组分分析-在线色谱分析解决方案.jpg'
  }
}
